import { addonVisibleForUserrole } from "../../utils/addonUtils";

type UserLike = { userRoles?: Array<{ name?: string }> };
type AddonLike = {
  limited_for_roles?: string[] | null;
  [key: string]: unknown;
};

/**
 * Filter a target-plan's addon list down to the entries the current user is
 * entitled to see. Wraps `addonVisibleForUserrole` (already the source of
 * truth for role-based addon visibility on the legacy /upgrade picker).
 * An addon with no `limited_for_roles` is public and shown to everyone.
 */
export function filterVisibleAddons<T extends AddonLike>(
  addons: ReadonlyArray<T>,
  user: UserLike | null | undefined,
): T[] {
  return addons.filter((addon) =>
    addonVisibleForUserrole(user?.userRoles, addon.limited_for_roles),
  );
}
